import { memo } from 'react';
import { Box, Button } from '@mui/material';
import { environment } from 'apps/table-tuck-web/src/environments/environment';

/**
 * Action buttons for cart (Add More Items + Go to Cart)
 * Memoized to prevent unnecessary re-renders
 */
const ActionButtons = memo(
  ({ onAddMoreItems, onGoToCart, hasErrors = false }) => {

    return (
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          zIndex: 10,
          padding: '16px 5%',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        {/* Add More Items Button */}
        <Button
          variant="outlined"
          onClick={onAddMoreItems}
          disableRipple
          sx={{
            textTransform: 'capitalize',
            padding: '14px 40px',
            width: '100%',
            boxShadow: 'none',
            fontWeight: 600,
            borderRadius: '43px',
            backgroundColor: 'white',
            color: environment.mainColor,
            border: `2px solid ${environment.mainColor}`,
            fontFamily: 'Jost',
            '&:hover': {
              backgroundColor: '#FFF4F0',
              border: `2px solid ${environment.mainColor}`,
              boxShadow: 'none',
            },
          }}
        >
          + Add More Items
        </Button>

        {/* Go to Cart Button */}
        <Button
          variant="contained"
          disabled={hasErrors}
          onClick={onGoToCart}
          disableRipple
          sx={{
            textTransform: 'capitalize',
            padding: '16px 40px',
            width: '100%',
            boxShadow: 'none',
            fontWeight: 600,
            borderRadius: '43px',
            backgroundColor: environment.mainColor,
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            fontFamily: 'Jost',
            '&:hover': {
              backgroundColor: environment.mainColor,
              boxShadow: 'none',
            },
            '&:disabled': {
              backgroundColor: '#ccc',
              color: '#999',
            },
          }}
        >
          Go to Cart
        </Button>
      </Box>
    );
  }
);

ActionButtons.displayName = 'ActionButtons';

export default ActionButtons;
